<template>
  <v-card class="card-prazo" color="orange darken-2">

    <v-container grid-list-md>
      <v-layout row wrap class="white--text text-xs-center title" align-center justify-center>
        <v-flex xs6 class="white--text title">
          <v-icon dark medium>event</v-icon>
          Prazo {{prazo}}
        </v-flex>
        <v-flex xs6>
          Faltam {{dias}} dias
        </v-flex>
      </v-layout>
    </v-container>

  </v-card>
</template>

<script>
export default {
  name: "ToolBarDate",
  props: {
    prazo: {
      type: [String, Number],
      required: true
    },
    dias: {
      type: [String, Number],
      required: true
    }
  }
};
</script>

<style lang="stylus">
  .prazo
    font-size: 18px
    font-weight: 500
    color: #ffffff
</style>



// WEBPACK FOOTER //
// src/components/ToolBarDate.vue